import { render } from "./reportOrderBillProfitDetails.vue?vue&type=template&id=563c5d80"
import script from "./reportOrderBillProfitDetails.vue?vue&type=script&lang=js"
export * from "./reportOrderBillProfitDetails.vue?vue&type=script&lang=js"

import "./reportOrderBillProfitDetails.vue?vue&type=style&index=0&id=563c5d80&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__